export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hey, I'm Shahid Zafar</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">Mern Stack</span>{" "}
            <br />
            Developer
          </h1>
          <p className="hero--section-description">
          MERN stack is a collection of technologies that enables faster application development.
          </p>
        </div>
        <button className="btn btn-primary">Get In Touch</button>
      </div>
      <div className="hero--section--img">
        <img src="./img/1.png" alt="Hero Section" />
      </div>
    </section>
  );
}
